export default __webpack_public_path__ + "static/rituals-0de85e4a444fdc89e88b627c5a813a3f.png";